export default {
  heading: "Create Password",
  submitHeading:"EdCity Account Activation",
  intro: "Please create password to activate your newly registrated EdCity account {id}.",
  submitBtn: "Submit",
  resetBtn: "Reset",
  closeBtn: "Close", 
  completed:
    "Activate account and update password successfully.",
  recordNotFound: "Sorry, the page you requested cannot be found.<br>Please check and retype the weblink or URL. For assistance, please contact us on <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>.",
  backToHome: "Back to homepage",
  hasActivated: "You have activated the account by visiting this link already.  The link has been expired.",
  expired: "The link has been expired.",
  userNotFound: "Fail to activate this account.",
};
